module.exports = __webpack_public_path__ + "a768e7de/img/arrow-share-icon.00a12c29.svg";